// §F13: backoff 1 → 2 → 5 → 10 → 30 s, poi polling di riserva ogni 15 s.
import type { SseEvent } from '../types';

export type SseStatus = 'connecting' | 'live' | 'reconnecting' | 'down' | 'polling';

const BACKOFF = [1000, 2000, 5000, 10_000, 30_000];
const BASE = import.meta.env.VITE_API_BASE ?? '/api';

export interface SseHandle {
  close: () => void;
  reconnect: () => void;
}

export function openStream(
  onEvent: (e: SseEvent) => void,
  onStatus: (s: SseStatus) => void,
): SseHandle {
  let stopped = false;
  let attempt = 0;
  let es: EventSource | null = null;
  let pollTimer: number | undefined;
  let retryTimer: number | undefined;

  function clearTimers() {
    if (pollTimer) window.clearInterval(pollTimer);
    if (retryTimer) window.clearTimeout(retryTimer);
    pollTimer = undefined;
    retryTimer = undefined;
  }

  function startPolling() {
    onStatus('polling');
    // un solo intervallo: ogni errore successivo non ne aggiunge un altro
    if (pollTimer) return;
    pollTimer = window.setInterval(
      () => onEvent({ type: 'runtime_patch', payload: { poll: true } }),
      15_000,
    );
  }

  function connectReal() {
    onStatus(attempt === 0 ? 'connecting' : 'reconnecting');
    es = new EventSource(BASE + '/stream', { withCredentials: true });
    es.onopen = () => {
      attempt = 0;
      clearTimers();
      onStatus('live');
    };
    es.onmessage = (m) => {
      try {
        onEvent(JSON.parse(m.data) as SseEvent);
      } catch {
        /* frame non parsabile: si ignora, il rifetch periodico riallinea */
      }
    };
    es.onerror = () => {
      es?.close();
      es = null;
      if (stopped) return;
      if (attempt >= 3) {
        startPolling();
      } else {
        onStatus('reconnecting');
      }
      const wait = BACKOFF[Math.min(attempt, BACKOFF.length - 1)];
      attempt += 1;
      if (retryTimer) window.clearTimeout(retryTimer);
      retryTimer = window.setTimeout(connectReal, wait);
    };
  }

  connectReal();

  return {
    close() {
      stopped = true;
      clearTimers();
      es?.close();
    },
    reconnect() {
      attempt = 0;
      clearTimers();
      es?.close();
      connectReal();
    },
  };
}
